<template>
  <v-row>
    <v-col cols="12" sm="10" md="5" lg="5" class="pb-0">
      <h1 class="pa-0 mb-10">Редактирование поля "paid" у квартир</h1>
      <v-form
        ref="formActivationDoorphone"
        v-model="valid"
        lazy-validation
        @submit.prevent="validate"
      >
        <v-row>
          <v-col cols="12" sm="10" md="8" lg="6" class="py-0">
            <v-text-field
              flat
              label="Номер квартиры"
              outlined
              prepend-inner-icon="mdi-home-account"
              v-model="apartment"
              dense
              type="number"
            ></v-text-field>
            <v-card-text
              class="pl-0 pr-0 pt-0 pb-0"
              v-if="selectedDoorphones[0] && selectedDoorphones[0].diapason"
            >
              Диапазон квартир: {{ selectedDoorphones[0].diapason }}.
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="10" md="8" lg="6" class="py-0 mt-0">
            <v-checkbox
              label="Оплачен"
              hide-details
              v-model='paid'
              dense
              color="success"
              class="pt-0"
              flat
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <div class="my-2 mt-4">
            <v-btn
              large
              color="success"
              class="text-none"
              dark
              @click="validate()"
            >
              Активировать
            </v-btn>
            <v-btn
              large
              class="ma-2 text-none"
              outlined
              dense
              hide-details
              color="error"
              @click="cancel()"
            >
              Отменить
            </v-btn>
          </div>
        </v-card-actions>
      </v-form>
    </v-col>
    <v-col class="pb-0">
      <v-card>
        <v-card-title>
          <span>Домофоны</span>
          <v-col cols="12" sm="10" md="10" lg="9">
            <v-text-field
              v-model="filterAddress"
              @keyup="validateKeyUp"
              label="Поиск по адресу или id"
              clearable
              dense
              autocomplete="chrome-off"
              hide-details
            ></v-text-field>
          </v-col>
          <v-btn
            dark
            class="btn blue darken-3 white px-7 text-none"
            @click.prevent="filterDoorphones"
          >
            Поиск
          </v-btn>
        </v-card-title>
        <v-data-table
          class="table"
          v-model="selectedDoorphones"
          :options.sync="options"
          :server-items-length="totalDoorphones"
          :headers="headersDoorphones"
          :items="doorphones"
          item-key="id"
          show-select
          :footer-props="{
            'items-per-page-options': [10, 20, 50, 100],
             showFirstLastPage: true,
          }"
          :single-select="true"
          :disable-sort="true"
        >
          <template v-slot:item.address="{ item }">
            <router-link class="routerLink" :to="`/doorphones/${item.id}`">
              {{ item.address }}
            </router-link>
          </template>
          <template v-slot:item.sip_status="{ item }">
            <div>
              <v-icon x-small :color="item.sip_status_color">
                mdi-checkbox-blank-circle
              </v-icon>
              {{ item.sip_status_text }}
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ApartmentPayment',
  data: () => ({
    isCreated: false,
    paid: true,
    apartment: null,
    selectedDoorphones: [],
    totalDoorphones: 0,
    filterAddress: '',
    options: {
      itemsPerPage: 10,
    },
    valid: true,
    filters: { status: 'null,0,1,2,3,4,5,6,7,-1', type: 'A,M,G' },
    sort: '',
    rules: {
      required: [
        v => !!v || 'Поле обязательно для заполнения',
      ],
      requiredTelephone: [
        v => !!v || 'Поле обязательно для заполнения',
        v => v >= 0 || 'Введите целое число',
        v => /^\d{11}$/.test(v) || 'Введите 11 цифр',
      ],
    },
    headersDoorphones: [
      {
        text: 'id',
        value: 'id',
      },
      {
        text: 'Адрес',
        value: 'address',
      },
      {
        text: 'Диапазон',
        value: 'diapason',
      },
      {
        text: 'Агент',
        value: 'agent',
      },
      {
        text: 'Управляющая компания',
        value: 'management_company',
      },
      {
        text: 'Статус',
        value: 'sip_status',
      },
    ],
  }),
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.updateSort();
          this.loadDoorphones();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
  },
  created () {
    this.isCreated = true;
    this.sort = ['-id'];
    if (Object.keys(this.$route.query).length) {
      const routeQuery = this.$route.query;

      if (routeQuery.address) {
        this.filterAddress = routeQuery.address;
        this.filters.address = routeQuery.address;
      }
    }
    this.loadDoorphones();
  },
  computed: {
    ...mapGetters({
      doorphones: 'Doorphone/doorphones',
    }),
  },
  methods: {
    ...mapActions({
      getDoorphones: 'Doorphone/getDoorphones',
      apartmentPayment: 'Apartment/apartmentPayment',
    }),
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.filterDoorphones();
      }
    },
    validate () {
      let doorphoneId;
      if (this.apartment === null) {
        this.$flash_danger('Введите номер квартиры');
        return;
      }
      if (!this.selectedDoorphones.length) {
        this.$flash_danger('Выберите домофон');
        return;
      } else {
        doorphoneId = this.selectedDoorphones[0].id;
      }
      this.editPaid(doorphoneId);
    },
    cancel () {
      this.paid = true;
      this.apartment = null;
      this.selectedDoorphones = [];
    },
    loadDoorphones () {
      this.getDoorphones({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sort: this.sort,
        filters: this.filters,
      })
        .then((response) => {
          this.totalDoorphones = response.meta.total;
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке домофонов');
        });
    },
    filterDoorphones () {
      this.options.page = 1;
      this.filters = { status: 'null,0,1,2,3,4,5,6,7,-1', type: 'A,M,G' };

      if (this.filterAddress) {
        if (!isNaN(this.filterAddress)) {
          this.filters.id = this.filterAddress;
          delete this.filters.address;
        } else {
          this.filters.address = this.filterAddress;
          delete this.filters.id;
        }
      }
      this.$router.push({
        query: {
          address: this.filters.address,
        },
      }).catch(() => {});
      this.loadDoorphones();
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
    },
    editPaid (doorphoneId) {
      this.apartmentPayment({
        doorphoneId: doorphoneId,
        apartment: this.apartment,
        paid: this.paid,
      })
        .then(() => {
          this.$flash_success('Изменения успешно сохранены, статуса оплтаты изменен');
        })
        .catch((e) => {
          console.error(e);
          this.$sentry_exception(e);
          this.$flash_warning('Произошла ошибка во время изменения статуса оплтаты');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}
</style>
